import type { MessagePayload } from 'firebase/messaging';

export const localFcmFake = {
  getToken: async () => 'local-fcm-token-male',
  onMessage: async (
    _callback: (payload: MessagePayload) => void,
  ): Promise<() => void> => () => undefined,
};
